module.exports = __webpack_public_path__ + "img/canada-pneumonia-female.e1b02054.png";